import React from 'react'
import { Platform } from 'react-native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'

import { HeaderAudioReconfigure } from 'src/resources/icons'

import { colors } from 'src/theme'
import { buildComponent } from 'src/components/factory'

import * as UI from 'native-base'
import * as Icons from 'src/components/icons'
import * as Semantics from 'src/components/semantics'

export const SectionButtons = buildComponent()
  .withLocale('screens.connected.player.components.section-buttons')
  .withLifecycle(() => {
    const insets = useSafeAreaInsets()
    // Sur iOS, le layout.tsx gère déjà le safeAreaTop, donc on n'ajoute pas de padding ici
    // Sur Android, on applique le paddingTop pour gérer la safe area
    const paddingTop = Platform.OS === 'ios' ? 0 : insets.top

    return { paddingTop }
  })
  .withRender(({ locale, lifecycle }) => (
    <UI.Row 
      justifyContent="space-between" 
      padding={2}
      paddingTop={2 + lifecycle.paddingTop}
    >
      <Semantics.LinkButton
        paddingLeft={Platform.OS === 'ios' ? 1 : 2}
        leftIcon={
          <Icons.FontAwesomeIcon
            color={colors.primary['700']}
            icon={
              Platform.OS === 'ios'
                ? Icons.Solid.faChevronLeft
                : Icons.Solid.faArrowLeft
            }
            size="lg"
          />
        }
        variant="ghost"
        toAction="replace"
        to="/player/evaluation"
        mergeParams
      >
        {locale('quit')}
      </Semantics.LinkButton>
      <Semantics.LinkButton
        rightIcon={
          <UI.Column width={20} height={20}>
            <HeaderAudioReconfigure width={20} height={20} />
          </UI.Column>
        }
        variant="ghost"
        toAction="replace"
        to="/category"
      >
        {locale('reconfigure')}
      </Semantics.LinkButton>
    </UI.Row>
  ))
